import { ColumnDef } from './types';

export function computeTotal<T>(col: ColumnDef<T>, rows: T[]): string {
  switch (col.totalType) {
    case 'sum': {
      if (!col.numericValue) return '';
      const sum = rows.reduce((acc, r) => acc + (col.numericValue!(r) || 0), 0);
      return sum.toLocaleString();
    }
    case 'unique': {
      const set = new Set(rows.map((r) => col.accessor(r)).filter(Boolean));
      return `${set.size} unique`;
    }
    case 'count':
    default: {
      const n = rows.filter((r) => !!col.accessor(r)).length;
      return `${n}`;
    }
  }
}

export function totalLabel(col: ColumnDef<any>): string {
  switch (col.totalType) {
    case 'sum': return 'Total';
    case 'unique': return 'Unique';
    case 'count':
    default: return 'Count';
  }
}

export function inlineTotal<T>(col: ColumnDef<T>, rows: T[]): string {
  switch (col.totalType) {
    case 'sum': {
      if (!col.numericValue) return '';
      const sum = rows.reduce((acc, r) => acc + (col.numericValue!(r) || 0), 0);
      return `total - ${sum.toLocaleString()}`;
    }
    case 'unique': {
      const set = new Set(rows.map((r) => col.accessor(r)).filter(Boolean));
      return `unique - ${set.size}`;
    }
    case 'count':
    default: {
      const n = rows.filter((r) => !!col.accessor(r)).length;
      return `count - ${n}`;
    }
  }
}
